import script from "./BgMusicStting.vue?vue&type=script&setup=true&lang=js"
export * from "./BgMusicStting.vue?vue&type=script&setup=true&lang=js"

import "./BgMusicStting.vue?vue&type=style&index=0&id=38e3c2d2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e3c2d2"]])

export default __exports__